/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeysUpdate } from "../../funcs/authApiKeysUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateScopedApiKeyRequest$inboundSchema,
};

export const tool$authApiKeysUpdate: ToolDefinition<typeof args> = {
  name: "auth-api-keys-update",
  description: `Update a scoped API key

Update a key's scopes (and optionally name / rate limit). Scopes already on the key are retained; newly-added scopes are bounded by the caller's role (and, for a key caller, the calling key's own scopes).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeysUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
